/* eslint-disable no-console */
import debug from "debug"

export const logger = {
  log: console.log,
  error: console.error,
  debug: debug("rentspree-auth-web"),
  info: console.info
}
